import { render, staticRenderFns } from "./SectionListItem.vue?vue&type=template&id=9da258bc&"
import script from "./SectionListItem.vue?vue&type=script&lang=js&"
export * from "./SectionListItem.vue?vue&type=script&lang=js&"
import style0 from "./SectionListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {LoadingOverlay: require('/lasso/components/LoadingOverlay.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9da258bc')) {
      api.createRecord('9da258bc', component.options)
    } else {
      api.reload('9da258bc', component.options)
    }
    module.hot.accept("./SectionListItem.vue?vue&type=template&id=9da258bc&", function () {
      api.rerender('9da258bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/wrappers/SectionListItem.vue"
export default component.exports